import { apiAxios } from '@/api'
import { keyBy } from 'lodash'

import {
  PlaidItem,
  receivePlaidItems,
} from '../reducers/finances/plaidItemReducer'
import { fetchIfNeededWrapper } from '../reducers/fetch'

// getPlaidItems
export const FETCH_PLAID_ITEM_KEY = 'FETCH_PLAID_ITEM_KEY'
export const fetchPlaidItemsIfNeeded = (alwaysFetch = false) =>
  fetchIfNeededWrapper({
    defaultErrorMessage:
      'There was an error fetching your connected Plaid accounts.',
    alwaysFetch,
    fetchKey: FETCH_PLAID_ITEM_KEY,
    fetchFunction: (dispatch) =>
      apiAxios.get<PlaidItem[]>('/finances/api/v1/plaid/items').then((json) => {
        dispatch(receivePlaidItems(keyBy(json.data, 'id')))
        return json.data
      }),
  })
